import React from 'react';
import PropTypes from 'prop-types';
import CoreMap from '@bd/bdui-coremap';
import { css } from '@bd/bdui-styles/emotion';
import { orderBy, get } from 'lodash';
import withData from '@bd/bdcore-data';

import CommunityCard from './CommunityCard';

const CommunitiesResults = ({ communities, sort }) => {
  return (
    <div className="community-results-wrapper">
      <ul className="CardsList list-unstyled cards-list-wrapper" style={{ position: 'relative', zIndex: 2 }}>
        {
          orderBy(communities, sort.field, get(sort, 'dir', 'asc')).map(community => (
            <li key={community._id}>
              <CommunityCard community={community} />
            </li>
          ))
        }
      </ul>
      <div className="map-section-wrapper">
        <CoreMap
          className={css`
            height: 100%;
            .leaflet-container {
              height: 100%;
            }
          `}
          markers={communities}
          boundaryPadding={4}
          pin={{
            iconUrl: '/images/icon-map-pin-blue.svg',
            iconSize: [21, 30],
            iconAnchor: [11, 30],
            popupAnchor: [0, -35],
          }}
          popup={({ marker: community }) => (
            <div className="community-popup">
              <CommunityCard community={community} hideMapPin />
            </div>
          )}
        />
      </div>
    </div>
  );
};

CommunitiesResults.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object),
  sort: PropTypes.object,
};

CommunitiesResults.defaultProps = {
  communities: [],
  sort: null,
};


export default withData(
  {
    communities: true,
  },
  {
    required: {
      communities: true,
    },
  },
)(CommunitiesResults);



// WEBPACK FOOTER //
// ./src/pages/Communities/CommunitiesResults.js